"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var recognizedItems_exports = {};
__export(recognizedItems_exports, {
  recognizedItems: () => recognizedItems
});
module.exports = __toCommonJS(recognizedItems_exports);
function recognizedItems(native) {
  return {
    [Symbol.asyncIterator]() {
      var queue = [];
      var waiting = [];
      var ended = false;
      var canceled = false;
      var end = function end2() {
        ended = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
        try {
          for (var _iterator = waiting.splice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var resolve = _step.value;
            resolve({
              done: true,
              value: void 0
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };
      var id = native.subscribeRecognizedItems(function(items) {
        if (ended) return;
        var resolve = waiting.shift();
        if (resolve) resolve({
          done: false,
          value: items
        });
        else queue.push(items);
      }, end);
      return {
        next() {
          var value = queue.shift();
          if (value) return Promise.resolve({
            done: false,
            value
          });
          if (ended) return Promise.resolve({
            done: true,
            value: void 0
          });
          return new Promise(function(resolve) {
            return waiting.push(resolve);
          });
        },
        async return() {
          queue.length = 0;
          end();
          if (!canceled) {
            canceled = true;
            native.unsubscribeRecognizedItems(id);
          }
          return {
            done: true,
            value: void 0
          };
        }
      };
    }
  };
}
//# sourceMappingURL=recognizedItems.js.map
